export var PlayerAdapterType;
(function (PlayerAdapterType) {
    PlayerAdapterType["AVIA"] = "avia";
})(PlayerAdapterType || (PlayerAdapterType = {}));
